// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"31":"99c0ae16d7c2a9df","367":"b94d2dfe27372ecb","412":"ff6239d802b99edf","543":"0cd6ce6b09f9261a","667":"52f9b57f952cd426","775":"01c54f40944540ce"}[chunkId] + ".js";
};